import { get, put } from "api/axiosApi";
import { env } from "utils/env";
const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function getOfferAssetClient(documentId, siteId, documentTypeId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/${documentTypeId}/assetclient`);
}

export function updateOfferAssetClient(documentId, siteId, client) {
  return put(url + `/leasingoffers/${documentId}/${siteId}/assetclient`, { documentId, siteId, ...client });
}
